<template>
  <div class="container">
    <div>
      <BFormInput
        ref="search"
        v-model="search"
        type="search"
        class="search mb-4"
        :placeholder="`Szukaj...`"
        @click="$refs.search.select()"
      />
    </div>
    <Loader
      v-if="pending"
    />
    <div
      v-for="c in sortedCategories"
      :key="c.id"
    >
      <div class="category-title">
        {{ c.name }}
      </div>
      <div class="row pb-5">
        <ListBadge
          v-for="b in c.badges"
          :key="b.id"
          v-bind="b"
          class="col-12 col-md-4"
          @click.native="open(b)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ListBadge from '@home/components/ListBadge';

const normalize = (str) => str.normalize('NFKD')
  .replace(/\u0142/g, 'l')
  .replace(/[\u0300-\u036F]/g, '');

const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const makeSearch = (search) => {
  if (!search) return () => true;
  const regex = new RegExp(normalize(escapeRegExp(search)), 'gi');
  return (str) => str && normalize(str.toString().toLowerCase()).search(regex) !== -1;
};


export default {
  props: {
    pending: Boolean,
  },
  data: () => ({
    search: '',
  }),
  components: {
    ListBadge,
  },
  computed: {
    ...mapState({
      badges: (state) => state.badges,
      categories: (state) => state.categories,
    }),
    sortedCategories() {
      return this.categories
        .slice()
        .sort((a, b) => a.ordinal - b.ordinal)
        .map((c) => ({
          ...c,
          badges: this.filteredBadges
            .filter((x) => x.category === c.id)
            .sort((a, b) => a.ordinal - b.ordinal),
        }))
        .filter((x) => x.badges.length > 0);
    },
    filteredBadges() {
      const search = makeSearch((this.search || '').toLowerCase());

      return (this.badges || [])
        .filter((x) => !this.search
          || search(x.spec.name)
          || x.spec.badges.some((y) => search(y.name))
          || x.spec.keywords.some((y) => search(y)));
    },
  },
  methods: {
    open(b) {
      this.$router.push(`/badge/${b.bid}`);
    },
  },
};
</script>

<style scoped>
  .search {
    border-radius: 15px;
  }

  .category-title {
    color: rgba(49,49,49,.9);
    font-weight: 600;
    text-transform: uppercase;
  }
</style>
